import styled from 'styled-components';

export const ModalWrapper = styled.div`
  background-color: rgb(0,0,0); /* Fallback color */
  background-color: rgba(0,0,0,0.4); /* Overlay effect: translucent background: black w/ partial opacity */
  z-index: 1; /* Overlay effect: positioned over other containers */
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  position: fixed; /* Fix position on the top-left corner*/
  top: 0;
  left: 0;
  overflow: auto; /* Enable scroll if needed */
  padding-top: 80px; /* Location of the content container */
`;

export const ModalContent = styled.div`
  box-shadow: #6c757d 1px 8px 10px;
  background-color: white;
  padding: 25px;
  width: 70%; /* Width in proportion to its parent container*/
  max-width: 720px; /* Max width where it stops expanding */
  margin: auto; /* Auto margin according to the element width */
  border-radius: 12px; /* Optional. Rounds container corners */
`;

export const ModalCloseButton = styled.div`
  color: #aaaaaa;
  float: right; /* Positioned to the right of the parent container whichever size it is */
  font-size: 20px;
  cursor: pointer;
  :hover {
    color: #000;
    text-decoration: none;
    cursor: pointer;
  }
`;

export const ModalTitle = styled.div`
  font-weight: 600;
  font-size: 24px;
  line-height: 40px;
  margin-bottom: 10px;
  flex: none;
  order: 0;
  flex-grow: 0;
`;

export const ModalSubtitle = styled.p`
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  flex: none;
  order: 1;
  flex-grow: 0;
  color: #595959
`;
